exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-username .header{height:50px}.page-username .main{height:87px;padding-top:15px;padding-left:34px;border-bottom:1px solid #DCDCDC}.page-username .main input::-webkit-input-placeholder{color:#8B9795}.page-username .main input:-moz-placeholder{color:#8B9795}.page-username .main input:-ms-input-placeholder{color:#8B9795}.page-username .main .name{font-size:12px;font-family:PingFangSC-Regular, PingFang SC;font-weight:400;color:#363737;margin-bottom:14px}.page-username .main .van-cell{font-size:16px}\n", ""]);

// exports
